/**
 * Dirección pública de una nota: `/2026/07/una-nota`.
 *
 * El año y el mes salen de `publishedAt` **en la zona del medio**, no en UTC: una nota
 * publicada el 31 de julio a las 23:30 en Bariloche es de julio, y en UTC ya sería agosto.
 * Sin esto, la URL que muestra el panel y la que resuelve el sitio no coincidirían durante
 * tres horas por día.
 *
 * Este es el **único** lugar donde se arma la URL de una nota: el editor la muestra, el
 * sitio público la resuelve y el `<link rel="canonical">` la usa. Si algún día se cambia el
 * formato, se cambia acá.
 */
/** Zona del medio. Fija por ahora: cuando haya un tenant en otra provincia, sale del tenant. */
export const ARTICLE_TIME_ZONE = 'America/Argentina/Buenos_Aires';
/** Año y mes de una fecha, en la zona del medio. */
export function articleDateParts(publishedAt) {
    const fecha = typeof publishedAt === 'string' ? new Date(publishedAt) : publishedAt;
    if (Number.isNaN(fecha.getTime()))
        throw new Error(`fecha de publicación inválida: ${String(publishedAt)}`);
    // `en-CA` da ISO (aaaa-mm-dd), que es lo único que se necesita partir.
    const [year = '', month = ''] = new Intl.DateTimeFormat('en-CA', {
        timeZone: ARTICLE_TIME_ZONE,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    })
        .format(fecha)
        .split('-');
    return { year, month };
}
/**
 * Ruta pública de una nota publicada. Para un borrador no existe: todavía no tiene fecha,
 * y la fecha es parte de la dirección.
 */
export function articlePath(publishedAt, urlKey) {
    const { year, month } = articleDateParts(publishedAt);
    return `/${year}/${month}/${urlKey}`;
}
